/* EVD AI Search — see sections/evd-ai-search.liquid */
(function () {
  'use strict';
  if (window.__evdAs) return;
  window.__evdAs = true;

  var root = document.querySelector('[data-evd-as]');
  if (!root) return;

  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('evd-as-config').textContent); } catch (e) { cfg = {}; }
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || cfg.root || '/';
  if (ROOT.slice(-1) !== '/') ROOT += '/';
  var SEARCH_URL = cfg.searchUrl || ROOT + 'search';
  var COLS = Array.isArray(cfg.collections) ? cfg.collections : [];
  var COL_BY = {};
  COLS.forEach(function (c) { COL_BY[c.h] = c; });

  function $(s) { return root.querySelector(s); }
  var input = $('[data-as-input]');
  var form = $('[data-as-form]');
  var clearBtn = $('[data-as-clear]');
  var micBtn = $('[data-as-mic]');
  var body = $('[data-as-body]');
  var aiBox = $('[data-as-ai]');
  var emptyBox = $('[data-as-empty]');
  var resultsBox = $('[data-as-results]');
  var productsBox = $('[data-as-products]');
  var countBox = $('[data-as-count]');
  var noneBox = $('[data-as-none]');
  var allLink = $('[data-as-all]');
  var suggWrap = $('[data-as-sugg-wrap]');
  var suggList = $('[data-as-sugg]');
  var collWrap = $('[data-as-coll-wrap]');
  var collList = $('[data-as-coll]');
  var recentWrap = $('[data-as-recent-wrap]');
  var recentBox = $('[data-as-recent]');
  var popularBox = $('[data-as-popular]');

  /* ---------- helpers ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function num(v) { var n = parseFloat(v); return isFinite(n) ? n : 0; }
  function sized(url, w) {
    if (!url) return '';
    try { var u = new URL(url, location.origin); u.searchParams.set('width', w); return u.toString(); } catch (e) { return url; }
  }
  function track(evt, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: evt }, data)); } catch (e) {}
  }

  // Prices in the shop's own format (e.g. "₹. {{amount}}" → "₹. 1,599.00").
  var MONEY = cfg.moneyFormat || '₹{{amount}}';
  function group(n, dec, thou, decSep) {
    var parts = Math.abs(n).toFixed(dec).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    return (n < 0 ? '-' : '') + parts.join(decSep);
  }
  function money(v) {
    var n = num(v);
    return MONEY.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return group(n, 0, ',', '.');
        case 'amount_with_comma_separator': return group(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(n, 2, "'", '.');
        default: return group(n, 2, ',', '.');
      }
    });
  }

  var ARROW = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 12h15M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ---------- open / close ---------- */
  var lastFocus = null;
  var isOpen = false;

  function open(q) {
    if (isOpen) { input.focus(); return; }
    isOpen = true;
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('evd-as-lock');
    void root.offsetWidth; // let the closed state paint so the reveal animates
    root.classList.add('is-open');
    renderRecent();
    loadPopular();
    if (q) input.value = q;
    setTimeout(function () { input.focus({ preventScroll: true }); }, 60);
    if (input.value.trim()) onInput(true); else showEmpty();
    track('evd_search_open', {});
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('evd-as-lock');
    abortAll();
    setTimeout(function () { if (!isOpen) root.hidden = true; }, 450);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  // Take over every search trigger in the theme (header icon, old popup, links to /search).
  var TRIGGERS = '[data-open-search-popup], m-search-popup, [data-evd-search-open], a[href="/search"], a[href^="/search?"], a[href="' + SEARCH_URL + '"]';
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest(TRIGGERS);
    if (!t || root.contains(t)) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    var q = '';
    if (t.tagName === 'A') { try { q = new URL(t.href, location.origin).searchParams.get('q') || ''; } catch (err) {} }
    open(q);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) { e.preventDefault(); close(); return; }
    if (e.key === '/' && !isOpen) {
      var a = document.activeElement;
      var typing = a && (a.tagName === 'INPUT' || a.tagName === 'TEXTAREA' || a.isContentEditable);
      if (!typing) { e.preventDefault(); open(''); }
    }
  });

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-as-close]')) { e.preventDefault(); close(); return; }
    var chip = e.target.closest('[data-as-q]');
    if (chip) {
      e.preventDefault();
      input.value = chip.getAttribute('data-as-q');
      onInput(true);
      input.focus({ preventScroll: true });
      body.scrollTop = 0;
      return;
    }
    if (e.target.closest('[data-as-recent-clear]')) { e.preventDefault(); saveRecentList([]); renderRecent(); return; }
    var link = e.target.closest('a[href]');
    if (link && input.value.trim()) remember(input.value.trim());
  });

  /* ---------- recent searches (this browser only) ---------- */
  var RKEY = 'evdAsRecent';
  function recentList() { try { return JSON.parse(localStorage.getItem(RKEY) || '[]') || []; } catch (e) { return []; } }
  function saveRecentList(list) { try { localStorage.setItem(RKEY, JSON.stringify(list)); } catch (e) {} }
  function remember(q) {
    q = q.slice(0, 80);
    var list = recentList().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    list.unshift(q);
    saveRecentList(list.slice(0, 5));
  }
  function renderRecent() {
    var list = recentList();
    recentWrap.hidden = !list.length;
    recentBox.innerHTML = list.map(function (q) {
      return '<li><button type="button" class="evd-as__word" data-as-q="' + esc(q) + '">' + esc(q) + '</button></li>';
    }).join('');
  }

  /* ---------- data ---------- */
  var memo = new Map();
  var controllers = {};
  function abort(name) { if (controllers[name]) { try { controllers[name].abort(); } catch (e) {} controllers[name] = null; } }
  function abortAll() { Object.keys(controllers).forEach(abort); }
  function ctl(name, ms) {
    abort(name);
    var c = new AbortController();
    controllers[name] = c;
    if (ms) setTimeout(function () { try { c.abort(); } catch (e) {} }, ms);
    return c.signal;
  }

  function getJSON(url, signal) {
    if (memo.has(url)) return Promise.resolve(memo.get(url));
    // No Accept: application/json header: Shopify would answer collection URLs with its own JSON instead of the evd-ai view.
    return fetch(url, { signal: signal, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (d) { memo.set(url, d); return d; });
  }

  function suggest(q, signal) {
    var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,query' +
      '&resources[limit]=8&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,tag,vendor';
    return getJSON(url, signal).then(function (d) { return (d.resources && d.resources.results) || {}; });
  }

  function feed(handle, params, signal) {
    var p = new URLSearchParams(params);
    p.set('view', 'evd-ai');
    return getJSON(ROOT + 'collections/' + encodeURIComponent(handle) + '?' + p.toString(), signal);
  }

  /* ---------- rendering ---------- */
  function card(p, i) {
    var price = num(p.price);
    var compare = num(p.compare);
    var onSale = compare > price;
    var off = onSale ? Math.round((1 - price / compare) * 100) : 0;
    var img = p.image
      ? '<img src="' + esc(sized(p.image, 480)) + '" srcset="' + esc(sized(p.image, 360)) + ' 360w, ' + esc(sized(p.image, 600)) + ' 600w" sizes="(min-width: 990px) 240px, 46vw" alt="" loading="lazy" width="480" height="640">'
      : '';
    return '<a class="evd-as__card' + (p.available === false ? ' is-out' : '') + '" href="' + esc(p.url) + '" style="--i:' + (i || 0) + '" data-as-item>' +
      '<span class="evd-as__card-img">' + img + (off >= 5 ? '<span class="evd-as__off"><i></i>' + off + '% off</span>' : '') + '</span>' +
      '<span class="evd-as__card-name">' + esc(p.title) + '</span>' +
      '<span class="evd-as__card-price">' +
        (onSale ? '<span class="is-sale">' + money(price) + '</span><s>' + money(compare) + '</s>' : '<span>' + money(price) + '</span>') +
      '</span></a>';
  }
  function cards(list) { return list.map(function (p, i) { return card(p, i); }).join(''); }
  function skeletons(n) {
    var s = '';
    for (var i = 0; i < n; i++) s += '<span><span class="evd-as__skel"></span><span class="evd-as__skel-line"></span><span class="evd-as__skel-line"></span></span>';
    return s;
  }

  function fromSuggest(p) {
    return {
      title: p.title,
      url: p.url,
      price: p.price,
      compare: p.compare_at_price_max,
      available: p.available,
      image: (p.featured_image && p.featured_image.url) || p.image || ''
    };
  }

  function showEmpty() {
    emptyBox.hidden = false;
    resultsBox.hidden = true;
    aiBox.hidden = true;
    aiBox.innerHTML = '';
    clearBtn.hidden = true;
  }

  var popularLoaded = false;
  function loadPopular() {
    if (popularLoaded || !cfg.popular || !popularBox) return;
    popularLoaded = true;
    popularBox.innerHTML = skeletons(4);
    feed(cfg.popular, {}).then(function (d) {
      var list = (d.products || []).filter(function (p) { return p.available !== false; }).slice(0, 4);
      if (!list.length) { popularBox.closest('.evd-as__group').hidden = true; return; }
      popularBox.innerHTML = cards(list);
    }).catch(function () { popularBox.closest('.evd-as__group').hidden = true; });
  }

  function showResultsShell() {
    if (!resultsBox.hidden) return;
    emptyBox.hidden = true;
    resultsBox.hidden = false;
    productsBox.innerHTML = skeletons(4);
    countBox.textContent = '';
    noneBox.hidden = true;
  }

  function renderInstant(q, res) {
    emptyBox.hidden = true;
    resultsBox.hidden = false;
    var products = (res.products || []).map(fromSuggest).slice(0, 8);
    productsBox.innerHTML = cards(products);
    countBox.textContent = products.length ? '(' + products.length + (products.length >= 8 ? '+' : '') + ')' : '';
    noneBox.hidden = products.length > 0;

    var queries = (res.queries || []).filter(function (s) { return s.text && s.text.toLowerCase() !== q.toLowerCase(); }).slice(0, 6);
    suggWrap.hidden = !queries.length;
    suggList.innerHTML = queries.map(function (s) {
      return '<li><button type="button" class="evd-as__word" data-as-q="' + esc(s.text) + '" data-as-item>' + (s.styled_text || esc(s.text)) + '</button></li>';
    }).join('');

    var cols = (res.collections || []).slice(0, 5);
    collWrap.hidden = !cols.length;
    collList.innerHTML = cols.map(function (c) {
      return '<li><a class="evd-as__word" href="' + esc(c.url) + '" data-as-item>' + esc(c.title) + '</a></li>';
    }).join('');

    allLink.href = SEARCH_URL + '?q=' + encodeURIComponent(q) + '&options[prefix]=last';
  }

  /* ---------- AI ---------- */
  var AI_WORDS = /\b(sale|offer|discount|deal|cheap|under|below|less|above|over|between|for|men|mens|man|him|women|womens|woman|her|girls|guys|gym|workout|yoga|running|party|winter|summer|office|casual|plus|size|xxl|3xl|4xl|5xl|6xl|new|latest|best|trending|matching|set|outfit|something|looking|need|want|show|gift)\b/i;
  function wantsAI(q) {
    if (!cfg.endpoint) return false;
    var words = q.trim().split(/\s+/);
    return words.length >= 3 || /\d/.test(q) || (words.length >= 2 && AI_WORDS.test(q));
  }

  var aiState = { q: '', result: null, pending: null };

  function askAI(q) {
    var key = 'ai:' + q.toLowerCase();
    if (memo.has(key)) return Promise.resolve(memo.get(key));
    var signal = ctl('ai', 8000);
    return fetch(cfg.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ q: q, collections: COLS.map(function (c) { return { h: c.h, t: c.t, g: c.g, k: c.k }; }) }),
      signal: signal
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.ok || !d.route) throw new Error((d && d.error) || 'ai');
        memo.set(key, d.route);
        return d.route;
      });
  }

  function findFilter(filters, re) { return filters.filter(function (f) { return f.type !== 'price_range' && re.test(f.label); })[0]; }

  function matchValues(filter, wanted, exact) {
    if (!filter || !wanted || !wanted.length) return [];
    var out = [];
    wanted.forEach(function (w) {
      var lw = String(w).toLowerCase().trim();
      filter.values.forEach(function (v) {
        var lv = String(v.label).toLowerCase().trim();
        var ok = exact ? lv === lw : (lv === lw || lv.indexOf(lw) !== -1);
        if (ok && v.count > 0 && out.indexOf(v) === -1) out.push(v);
      });
    });
    return out;
  }

  function itemWords(terms) {
    var generic = /^(wear|clothe|clothes|cloth|outfit|outfits|stuff|thing|things|something|item|items|gym|workout|men|women|for|the|and|sale)$/;
    return String(terms || '').toLowerCase().split(/[^a-z0-9-]+/).filter(function (w) { return w.length > 2 && !generic.test(w); })
      .map(function (w) { return w.replace(/(es|s)$/, ''); });
  }
  function matchesItem(p, words) {
    var hay = ((p.title || '') + ' ' + (p.type || '')).toLowerCase();
    return words.some(function (w) { return hay.indexOf(w) !== -1; });
  }

  function hasColour(p, colours) {
    var hay = ((p.colors || []).join(' ') + ' ' + (p.title || '')).toLowerCase();
    return colours.some(function (c) { return hay.indexOf(String(c).toLowerCase()) !== -1; });
  }

  function resolveRoute(route) {
    var signal = ctl('resolve', 8000);
    if (route.mode === 'collection' && route.collection) {
      var handle = route.collection;
      var col = COL_BY[handle] || {};
      var hasPrice = route.price_min || route.price_max;
      var params = new URLSearchParams();
      var sort = route.sort && route.sort !== 'relevance' ? route.sort : ((route.price_max && !route.price_min) || route.on_sale ? 'price-ascending' : '');
      if (sort) params.set('sort_by', sort);

      return feed(handle, params, signal).then(function (first) {
        var filters = first.filters || [];
        var p = new URLSearchParams(params);
        var applied = [];

        var priceF = filters.filter(function (f) { return f.type === 'price_range'; })[0];
        if (priceF && hasPrice) {
          if (route.price_min) p.set(priceF.min_param, route.price_min);
          if (route.price_max) p.set(priceF.max_param, route.price_max);
          applied.push('price');
        }

        if (route.gender && /unisex/i.test(col.g || '')) {
          var genderF = findFilter(filters, /gender/i);
          var want = route.gender === 'men' ? ['male', 'men', 'unisex'] : ['female', 'women', 'unisex'];
          matchValues(genderF, want, true).forEach(function (v) { p.append(v.param, v.value); applied.push('gender'); });
        }

        var colorF = findFilter(filters, /colou?r/i);
        var colorVals = matchValues(colorF, route.colors, false);
        colorVals.forEach(function (v) { p.append(v.param, v.value); });
        if (colorVals.length) applied.push('colour');

        var sizeF = findFilter(filters, /size/i);
        var sizeVals = matchValues(sizeF, route.sizes, true);
        sizeVals.forEach(function (v) { p.append(v.param, v.value); });
        if (sizeVals.length) applied.push('size');

        var next = applied.length ? feed(handle, p, signal) : Promise.resolve(first);
        return next.then(function (d) {
          if (d.count === 0 && (colorVals.length || sizeVals.length)) {
            colorVals.concat(sizeVals).forEach(function (v) { p.delete(v.param); });
            return feed(handle, p, signal).then(function (d2) { return { d: d2, relaxed: true }; });
          }
          return { d: d, relaxed: false };
        }).then(function (x) {
          var d = x.d;
          var list = (d.products || []).slice();
          var narrowed = false;
          var notes = [];

          // Item words ("cargo") keep broad collections on topic.
          // Only for broad collections (sale, new in, bestsellers, all men/women...); a category
          // collection like Men's Cargos is already on topic.
          var broad = /sale|clearance|new-in|best|most-loved|pre-launch|plussize|all-|^male$|^female$/.test(handle) || /unisex/i.test(col.g || '');
          var words = broad ? itemWords(route.search_terms) : [];
          if (words.length) {
            var byItem = list.filter(function (pr) { return matchesItem(pr, words); });
            if (byItem.length) { if (byItem.length < list.length) narrowed = true; list = byItem; }
          }
          if (route.on_sale) {
            var bySale = list.filter(function (pr) { return num(pr.compare) > num(pr.price); });
            if (bySale.length) { if (bySale.length < list.length) narrowed = true; list = bySale; }
            else notes.push('Nothing on sale here right now — showing the best prices');
          }
          // Price / colour the collection can't filter by: narrow the preview here.
          if (hasPrice && !priceF) {
            var byPrice = list.filter(function (pr) {
              var v = num(pr.price);
              return (!route.price_min || v >= route.price_min) && (!route.price_max || v <= route.price_max);
            });
            if (byPrice.length) { list = byPrice; narrowed = true; }
            else notes.push('Nothing in that price range — showing the lowest prices');
          }
          if (route.colors && route.colors.length && !colorVals.length) {
            var byColour = list.filter(function (pr) { return hasColour(pr, route.colors); });
            if (byColour.length) { list = byColour; narrowed = true; }
            else notes.push('No ' + route.colors.join(' / ') + ' pieces here right now — showing the closest');
          }
          if (x.relaxed) notes.push('Your size was limited here, so we widened it slightly');

          var more = d.count > (d.products || []).length;
          var count = narrowed ? list.length + (more ? '+' : '') : d.count;
          var qs = p.toString();
          return {
            url: ROOT + 'collections/' + handle + (qs ? '?' + qs : ''),
            title: col.t || d.title,
            count: count,
            products: list.slice(0, 4),
            note: notes.join('. ')
          };
        });
      });
    }
    var terms = route.search_terms || aiState.q;
    return suggest(terms, signal).then(function (res) {
      return {
        url: SEARCH_URL + '?q=' + encodeURIComponent(terms) + '&options[prefix]=last',
        title: terms,
        count: null,
        products: (res.products || []).slice(0, 4).map(fromSuggest),
        note: ''
      };
    });
  }

  function renderAILoading() {
    aiBox.hidden = false;
    aiBox.innerHTML =
      '<div class="evd-as__ai-card is-loading">' +
        '<div><p class="evd-as__ai-kicker"><i aria-hidden="true">✦</i> Everdion AI</p>' +
        '<p class="evd-as__ai-reply">Styling your search<span class="evd-as__dots" aria-hidden="true"><i></i><i></i><i></i></span></p></div>' +
        '<div class="evd-as__ai-picks">' + '<span class="evd-as__skel"></span>'.repeat(4) + '</div>' +
      '</div>';
  }

  function renderAI(route, r) {
    var alts = (route.alternates || []).map(function (h) { return COL_BY[h]; }).filter(Boolean);
    var label = r.count == null ? 'See the results' : (String(r.count) === '1' ? 'Shop 1 piece' : 'Shop ' + r.count + ' pieces');
    aiBox.hidden = false;
    aiBox.innerHTML =
      '<div class="evd-as__ai-card">' +
        '<div class="evd-as__ai-copy">' +
          '<p class="evd-as__ai-kicker"><i aria-hidden="true">✦</i> Everdion AI · ' + esc(r.title) + '</p>' +
          '<p class="evd-as__ai-reply">' + esc(route.reply || ('Top picks in ' + r.title)) + '</p>' +
          (r.note ? '<p class="evd-as__ai-note">' + esc(r.note) + '</p>' : '') +
          '<div class="evd-as__ai-actions">' +
            '<a class="evd-as__ai-go" href="' + esc(r.url) + '" data-as-item data-as-ai-go>' + esc(label) + ARROW + '</a>' +
            alts.map(function (c) { return '<a class="evd-as__ai-alt" href="' + esc(c.u || (ROOT + 'collections/' + c.h)) + '" data-as-item>' + esc(c.t) + '</a>'; }).join('') +
          '</div>' +
        '</div>' +
        (r.products.length ? '<div class="evd-as__ai-picks">' + cards(r.products) + '</div>' : '') +
      '</div>';
  }

  function runAI(q) {
    if (!wantsAI(q)) { aiBox.hidden = true; aiBox.innerHTML = ''; aiState = { q: q, result: null, pending: null }; return null; }
    if (aiState.q === q && (aiState.result || aiState.pending)) return aiState.pending || Promise.resolve(aiState.result);
    aiState = { q: q, result: null, pending: null };
    renderAILoading();
    var started = Date.now();
    var pending = askAI(q).then(function (route) {
      return resolveRoute(route).then(function (r) {
        if (aiState.q !== q) return null;
        aiState.result = r;
        aiState.pending = null;
        renderAI(route, r);
        track('evd_ai_search', { search_term: q, ai_collection: route.collection || '', ai_mode: route.mode, ai_ms: Date.now() - started });
        return r;
      });
    }).catch(function (err) {
      if (aiState.q === q) { aiState.pending = null; aiBox.hidden = true; aiBox.innerHTML = ''; }
      if (!(err && err.name === 'AbortError')) track('evd_ai_search_error', { search_term: q });
      return null;
    });
    aiState.pending = pending;
    return pending;
  }

  /* ---------- typing ---------- */
  var tInstant = null;
  var tAI = null;

  function onInput(now) {
    var q = input.value.trim();
    clearBtn.hidden = !input.value;
    clearTimeout(tInstant); clearTimeout(tAI);
    if (q.length < 2) {
      abortAll();
      aiState = { q: '', result: null, pending: null };
      showEmpty();
      clearBtn.hidden = !input.value;
      return;
    }
    showResultsShell();
    tInstant = setTimeout(function () {
      suggest(q, ctl('instant')).then(function (res) {
        if (input.value.trim() === q) renderInstant(q, res);
      }).catch(function () {});
    }, now ? 0 : 90);
    if (aiState.q && aiState.q !== q) { abort('ai'); abort('resolve'); aiBox.hidden = true; aiBox.innerHTML = ''; aiState = { q: '', result: null, pending: null }; }
    tAI = setTimeout(function () { runAI(q); }, now ? 0 : 650);
  }

  input.addEventListener('input', function () { onInput(false); });

  clearBtn.addEventListener('click', function () {
    input.value = '';
    onInput(true);
    input.focus({ preventScroll: true });
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var q = input.value.trim();
    if (!q) { input.focus(); return; }
    remember(q);
    var fallback = SEARCH_URL + '?q=' + encodeURIComponent(q) + '&options[prefix]=last';
    clearTimeout(tAI);
    var p = wantsAI(q) ? runAI(q) : null;
    if (!p) { location.href = fallback; return; }
    p.then(function (r) { location.href = (r && r.url) || fallback; });
  });

  // Arrow keys move through results; Enter on the input submits.
  root.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var items = Array.prototype.filter.call(body.querySelectorAll('[data-as-item], [data-as-q]'), function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var i = items.indexOf(document.activeElement);
    if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[0]).focus(); }
    if (e.key === 'ArrowUp') { e.preventDefault(); if (i <= 0) input.focus(); else items[i - 1].focus(); }
  });

  /* ---------- voice ---------- */
  var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (SR && micBtn) {
    micBtn.hidden = false;
    var rec = null;
    micBtn.addEventListener('click', function () {
      if (rec) { try { rec.stop(); } catch (e) {} return; }
      try {
        rec = new SR();
        rec.lang = 'en-IN';
        rec.interimResults = true;
        rec.maxAlternatives = 1;
        micBtn.classList.add('is-on');
        rec.onresult = function (ev) {
          var t = '';
          for (var i = 0; i < ev.results.length; i++) t += ev.results[i][0].transcript;
          input.value = t;
          var last = ev.results[ev.results.length - 1];
          onInput(!!(last && last.isFinal));
        };
        rec.onend = rec.onerror = function () { micBtn.classList.remove('is-on'); rec = null; };
        rec.start();
      } catch (e) { micBtn.classList.remove('is-on'); rec = null; }
    });
  }

  window.EvdSearch = { open: open, close: close };
})();
